<nz-spin [nzSpinning]="isLoading" [nzIndicator]="purpleModalLoaderTemplate">
  <app-purple-form *ngIf="purpleFormFieldGroups!= undefined" [disbledForm]="disableForm" [(formGroup)]="validateForm"
    [purpleFormFieldGroups]="purpleFormFieldGroups">
  </app-purple-form>
</nz-spin>
<ng-template #purpleModalLoaderTemplate>
  <div class="purple-modal-custom-spinner">
    <span nz-icon nzType="loading"></span>
  </div>
</ng-template>
<div class="purple-button-container ps-w-100 ps-d-flex">
  <button (click)="testSmtp()" nz-button class="purple-modal-button secondary ps-mr-1" [disabled]="isTestLoading"
    [nzLoading]="isTestLoading">
    {{ 'smtp_test_configuration_edit' | translation: 'Testa Configurazione': []}}
  </button>
  <button (click)="editSmtpServer()" nz-button class="purple-modal-button ps-ml-1" [disabled]="isLoading"
    [nzLoading]="isLoading">
    {{ 'edit_modal_save_button' | translation: 'Salva {0}': ['modifiche']}}
  </button>
</div>